import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import ProductCard from "./ProductCard";

export default function ProductCarousel({ products, testid }) {
  const track = useRef(null);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);

  const update = () => {
    const el = track.current;
    if (!el) return;
    setCanPrev(el.scrollLeft > 4);
    setCanNext(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  };

  useEffect(() => {
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, [products]);

  const nudge = (dir) => {
    const el = track.current;
    if (el) el.scrollBy({ left: dir * el.clientWidth * 0.8, behavior: "smooth" });
  };

  return (
    <div className="relative" data-testid={testid}>
      <div
        ref={track}
        onScroll={update}
        className="flex gap-5 lg:gap-8 overflow-x-auto snap-x snap-mandatory pb-2 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden"
      >
        {products.map((p, i) => (
          <div key={p.id} className="snap-start shrink-0 basis-[68%] sm:basis-[40%] lg:basis-[23%]">
            <ProductCard product={p} index={i} />
          </div>
        ))}
      </div>
      {canPrev && (
        <button
          onClick={() => nudge(-1)}
          data-testid={`${testid}-prev`}
          aria-label="Scroll back"
          className="absolute top-[38%] -translate-y-1/2 -left-3 lg:-left-5 z-10 w-10 h-10 flex items-center justify-center border border-gold/40 bg-ink/85 backdrop-blur text-gold hover:bg-gold hover:text-ink transition-colors duration-300"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>
      )}
      {canNext && (
        <button
          onClick={() => nudge(1)}
          data-testid={`${testid}-next`}
          aria-label="Scroll forward"
          className="absolute top-[38%] -translate-y-1/2 -right-3 lg:-right-5 z-10 w-10 h-10 flex items-center justify-center border border-gold/40 bg-ink/85 backdrop-blur text-gold hover:bg-gold hover:text-ink transition-colors duration-300"
        >
          <ChevronRight className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
